export const VALIDATION_DEFAULT_VALUES = {
  maxText: 1000,
};

export const VALIDATION_DEFAULT_TEXT = {
  maxText: `${VALIDATION_DEFAULT_VALUES.maxText}文字まででお願いします`,
  required: "入力してください",
  email: "正しいメールアドレスを入力してください",
};

export const VALIDATION_DEFAULT_NUMBER = {
  required: "入力してください",
  max: "より小さな数字を入力してください",
  min: "より大きな数字を入力してください",
};

export const VALIDATION_DEFAULT_MESSAGE = {
  required: "入力してください",
};

export const VALIDATION_CHOICE = {
  required: "選択してください",
  accepted: "同意するをチェックしてください",
};
